import React, { Component } from 'react';
import moment from 'moment';

const DATE_FORMAT = 'DD-MM-YYYY';
const DATETIME_FORMAT = 'DD-MM-YYYY HH:mm:ss';

class DateDisplay extends Component {
  render() {
    const { value } = this.props;
    if (!value) return (<span className="datetime">--/--/--</span>);

    let { format } = this.props;
    if (!format) format = DATETIME_FORMAT;
    else if (format === 'date') format = DATE_FORMAT;
    else if (format === 'datetime') format = DATETIME_FORMAT;
    return (
      <span className="datetime">
        {moment(value).format(format)}
      </span>
    );
  }
}

DateDisplay.defaultProps = {
  format: DATE_FORMAT,
};

export default DateDisplay;



// WEBPACK FOOTER //
// ./src/components/Common/DateDisplay.js